import { 
    TOUR_CUSTOMER_BOOKING_DETAILS_API_START,
    TOUR_CUSTOMER_BOOKING_DETAILS_API_SUCCESS,
    TOUR_CUSTOMER_BOOKING_DETAILS_API_ERROR
} from "../Constant/BookingDetailConstant";

const initialstate = {
    loading: false,
    message: "",
    data: []
}

export default function BookingDetailReducer(state= {...initialstate}, action) {
    switch (action.type){
        case TOUR_CUSTOMER_BOOKING_DETAILS_API_START:
            return {
                ...state,
                loading: true
            };
        case TOUR_CUSTOMER_BOOKING_DETAILS_API_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload
            };
        case TOUR_CUSTOMER_BOOKING_DETAILS_API_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default: 
            return state;
    }
}